import type { EventCategory } from "@/types/content";

interface FilterBarProps {
  categories: EventCategory[];
  activeCategory: string;
  keyword: string;
  sort: string;
  resultCount: number;
  onKeywordInput: (value: string) => void;
  onKeywordSubmit: (value: string) => void;
  onCategoryChange: (slug: string) => void;
  onSortChange: (value: string) => void;
}

export default function FilterBar({
  categories,
  activeCategory,
  keyword,
  sort,
  resultCount,
  onKeywordInput,
  onKeywordSubmit,
  onCategoryChange,
  onSortChange,
}: FilterBarProps) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-100 p-4 md:p-5">
      <form
        onSubmit={(event) => {
          event.preventDefault();
          onKeywordSubmit(keyword);
        }}
        className="flex flex-col md:flex-row gap-3"
      >
        <div className="relative flex-1">
          <span className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center text-foreground-400">
            <i className="ri-search-2-line" />
          </span>
          <label htmlFor="events-search" className="sr-only">
            搜索事件
          </label>
          <input
            id="events-search"
            name="q"
            type="text"
            value={keyword}
            onChange={(event) => onKeywordInput(event.target.value)}
            placeholder="输入事件名称、关键词或证据类型"
            className="w-full h-11 pl-11 pr-4 rounded-md bg-background-50 border border-background-200 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-400/30"
          />
        </div>
        <div className="flex gap-3">
          <label htmlFor="events-sort" className="sr-only">
            排序方式
          </label>
          <select
            id="events-sort"
            value={sort}
            onChange={(event) => onSortChange(event.target.value)}
            className="h-11 px-3 rounded-md bg-background-50 border border-background-200 text-sm text-foreground-800 focus:outline-none focus:border-primary-400 cursor-pointer"
          >
            <option value="updated">按更新时间</option>
            <option value="heat">按热度</option>
            <option value="evidence">按证据数量</option>
          </select>
          <button
            type="submit"
            className="h-11 px-5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            搜索
          </button>
        </div>
      </form>

      <div className="mt-4 flex flex-wrap items-center gap-2">
        <button
          type="button"
          onClick={() => onCategoryChange("all")}
          className={`px-3.5 py-1.5 rounded-full text-xs md:text-sm border transition-colors cursor-pointer whitespace-nowrap ${
            activeCategory === "all"
              ? "bg-primary-500 border-primary-500 text-background-50"
              : "border-background-200 text-foreground-600 hover:border-primary-300 hover:text-primary-500"
          }`}
        >
          全部类型
        </button>
        {categories.map((category) => (
          <button
            key={category.slug}
            type="button"
            onClick={() => onCategoryChange(category.slug)}
            className={`px-3.5 py-1.5 rounded-full text-xs md:text-sm border transition-colors cursor-pointer whitespace-nowrap ${
              activeCategory === category.slug
                ? "bg-primary-500 border-primary-500 text-background-50"
                : "border-background-200 text-foreground-600 hover:border-primary-300 hover:text-primary-500"
            }`}
          >
            {category.name}
          </button>
        ))}
        <span className="ml-auto text-xs md:text-sm text-foreground-500">共 {resultCount} 起事件</span>
      </div>
    </div>
  );
}